<div class="container-fluid">
    <div class="row mt-5 justify-content-center align-items-center">
        <div class="col-auto">
            <iim-spinner size="medium" color="primary"></iim-spinner>
        </div>
        <div class="col-auto">
            <em class="fas fa-clock"></em>
            {{ 'Die Aufgabe wird geladen... Bitte warten Sie einen Moment!' | translate }}
        </div>
    </div>
</div>
